import { useCallback, useRef } from 'react';
import { useSafeLayoutEffect } from './use-safe-layout-effect.js';

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 */
export function useCallbackRef<T extends (...args) => unknown>(
  fn: T | undefined
): T {
  const ref = useRef(fn);

  useSafeLayoutEffect(() => {
    ref.current = fn;
  });

  return useCallback(((...args) => ref.current?.(...args)) as T, []);
}
